export const jobsIcon = (subicon)=>[
        'cogs',
        {
            name: subicon,
            color: 'grey'
        }
    ];
export const state_icons = {
    NEW: {
        color: 'blue',
        name: 'flag outline'
    },
    RUNNING: {
        color: 'green',
        name: 'cog',
        loading: true
    },
    STARTING: {
        color: 'black',
        name: 'play circle outline'
    },
    STARTING_EXTERNAL: {
        color: 'black',
        name: 'play circle outline'
    },
    STARTING_WAITING: {
        color: 'black',
        name: 'play circle outline'
    },
    STOPPING: {
        color: 'grey',
        name: 'stop'
    },
    SKIPPED: {
        color: 'black',
        name: 'play circle outline'
    },
    READY: {
        color: 'green',
        name: 'flag checkered'
    },
    READY_ERROR: {
        color: 'red',
        name: 'flag checkered'
    },
    READY_STOPPED: {
        color: 'grey',
        name: 'flag checkered'
    },
    READY_FAILED: {
        color: 'red',
        name: 'flag checkered'
    },
    TERMINATED: {
        color: 'orange',
        name: 'flag checkered'
    },
    BROKEN: {
        color: 'red',
        name: 'flag checkered'
    }
};
